export const ALLOWED_LINK_PLATFORMS: string[] = [
  'onlyfans.com',
  'instagram.com',
  'tiktok.com',
  'linktr.ee',
  'snipfeed.co',
  'msha.ke',
  'carrd.co',
  'hoo.be',
  'solo.to',
  'shor.by',
  'campsite.bio',
  'allmylinks.com',
  'link.me',
]
